module.exports = require('./src/HighchartsReact.js')
